
import { defineComponent } from 'vue';
import { emptyTournament, Tournament, defaultPlayer } from '@/views/interfaces/entities.ts';
import TournamentBrackets from './Main/TournamentBrackets.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default defineComponent({
  name: 'edit-tournament',
  components: {
    TournamentBrackets,
  },
  data() {
    return {
      startable: true,
      savedPositions: new Set(),
      positionsCopy:[],
      tournamentSettings: {
        name: '',
        size: '',
        matchTime: '',
      },
      loading: {
        matchCard: false,
        tournament: true,
        tournamentCard: false,
      },
      emptyTournament: emptyTournament,
      defaultPlayer: defaultPlayer,
    }
  },
  computed: {
    ...mapGetters({
      match: 'tournament/getMatch',
      tournament: 'tournament/getTournament',
    }),
    playerLeftSavable() {
      try {
        if(this.positionsCopy.length === 0) return false;
        const { id, player } = this.match.posLeft;
        const positionCopy = this.positionsCopy.find((position) => position.id === id);
        const { name, avatar } = player;
        const { name: nameCopy, avatar: avatarCopy } = positionCopy.player;
        return name !== nameCopy || avatar !== avatarCopy;  
      } catch (error) {
        return false;
      }
    },
    playerRightSavable() {
      try {
        if(this.positionsCopy.length === 0) return false;
        const { id, player } = this.match.posRight;
        const positionCopy = this.positionsCopy.find((position) => position.id === id);
        const { name, avatar } = player;
        const { name: nameCopy, avatar: avatarCopy } = positionCopy.player;
        return name !== nameCopy || avatar !== avatarCopy;        
      } catch (error) {
        return false;
      }
    },
    settingsSavable(){
      try {
        const { name, size, matchTime } = this.tournament;
        const { name: nameCopy, size: sizeCopy, matchTime: matchTimeCopy } = this.tournamentSettings;
        return name !== nameCopy || size !== sizeCopy || matchTime !== matchTimeCopy;
      } catch (error) {
        return false
      }
    }
  },
  async created() {
    this.resetMatch();
    this.resetTournament();
    if (this.$route.params.id){ 
      await this.loadTournament(this.$route.params.id);
      if (this.isNotDraft()) this.$router.push({ name: 'tournament-view', params: { id: this.tournament.id } });
    }  
    else { 
      await this.saveTournament(<Tournament>this.emptyTournament);
    }
    this.setPositionsCopy();
    this.setTournamentSettings();
    this.selectDefaultMatch();
    this.loading.tournament = false;
  },
  methods: {
    ...mapMutations({
      setTournament: 'tournament/SET_TOURNAMENT',
      resetMatch: 'tournament/RESET_MATCH',
      resetTournament: 'tournament/RESET_TOURNAMENT',
    }),
    ...mapActions({
      saveTournament: 'tournament/save',
      loadTournament: 'tournament/get',
      savePosition: 'tournament/savePosition',
      selectMatch: 'tournament/selectMatch',
    }),
    selectDefaultMatch() {
      this.selectMatch(this.tournament.positions[0].nextPos);
    },
    async saveCardLoading() {
      this.loading.matchCard = true;
      
      if(this.playerLeftSavable) {
       await this.savePosition(this.match.posLeft);
       this.savedPositions.add(this.match.posLeft.id);
      }

      if(this.playerRightSavable) {
        await this.savePosition(this.match.posRight);
        this.savedPositions.add(this.match.posRight.id);
      }
      
      this.setPositionsCopy();
      this.loading.matchCard = false;
    },

    async updateTournament() {
      this.loading.tournamentCard = true;
      await this.saveTournament(this.tournament);
      this.setTournamentSettings();
      this.loading.tournamentCard = false;

    },
    async start() {
      this.loading.tournamentCard = true;
      const tournament = this.tournament;
      tournament.status = 'start';
      await this.saveTournament(tournament);
      this.loading.tournamentCard = false;
      this.$router.push({ name: 'tournament-view', params: { id: tournament.id } });
    },
    isNotDraft() {
      return this.tournament.status !== 'draft' && this.tournament.status !== '';
    },
    setTournamentSettings(){
      const { name, size, matchTime } = this.tournament;
      this.tournamentSettings = {...this.tournamentSettings, name, size, matchTime };
    },
    setPositionsCopy(){ // TODO: refactor remove/add to fix bug. 
      this.positionsCopy = JSON.parse(JSON.stringify(this.tournament.positions));
    }
  }
});
